goog.provide('el8.ptdata.ptImmunizationDeclines');

goog.require('el8.model.base');
goog.require('el8.ptdata.model.PatientItemSet');

el8.ptdata.ptImmunizationDeclines = (function() {

    var _class = function(spec) { this.populate(spec); };
    _class.inheritsFrom(el8_Entity);
    _class.makePatientItem();

    _class.prototype.populate = function(spec) {
        spec = spec || {};
        this.parent.populate.call(this, spec);
    };
    _class.addDateTime('declinedDate', true);
    _class.addStringProperty('cdcType', true);
    _class.addStringProperty('declinedReason', true);
    _class.addBoolean('immunity', true);
    _class.addIntProperty('vaccineId', true);
    _class.addStringProperty('allowedSharing', true);
    _class.addStringProperty('selectImmunizationRegistry', true);
    _class.addStringProperty('patientConsent', true);

    /**
     * Custom asSoyMap method
     */
    _class.prototype.asSoyMap = function() {
        var mapped = this.parent.asSoyMap.call(this);
        mapped.submissionId = this.rawData.submission && this.rawData.submission.id;
        mapped.submission = this.rawData.submission;

        return mapped;
    };

    /**
     *  HELPER METHODS
     */
    _class.prototype.getNoteSummary = function() {
        return el8.template.ptdata.ptImmunizationDeclines.noteSummary(this.asSoyMap()).el8_unescape();
    };

    var that = new el8.ptdata.model.PatientItemSet({
        model: function(spec) { return new _class(spec); },
        urlLoad: function() { return el8.service.urls.get('ptImmunizationDeclines'); },
        saveFn: function(item, successCbFn) {
            el8.appservice.notifier.notify('Declined immunization being saved...');
            $.el8_ajax({
                url: el8.service.urls.get('ptImmunizationDeclines', [item]),
                type: 'POST',
                async: false,
                data: JSON.stringify(item.asMap(true)),
                success: function(data) {
                    if (item.getId()) {
                        el8.ptdata.ptImmunizationDeclines.updateItemId(item, data.item.id);
                    }
                    item.populate(data.item);
                    if (successCbFn) { successCbFn(item); }
                    el8.appservice.notifier.notify('Declined immunization saved.');
                }
            });
        },
        deleteFn: function(item, successCbFn) {
            el8.appservice.notifier.notify('Declined immunization being deleted...');
            $.el8_ajax({
                url: el8.service.urls.get('ptImmunizationDeclines', [item]),
                type: 'DELETE',
                success: function(data) {
                    el8.appservice.notifier.notify('Declined immunization deleted.');
                    if (successCbFn) { successCbFn(item); }
                }
            });
        }
    });

    that.addPatientImmunity = function(spec) {
        // "patient has immunity" is a specific kind of immunization decline
        var newDeclineCb = function(item) {
            el8.appchart.mgr.notes.addReference({item: item, sectionName: 'tx'});
        };
        spec = spec || {};
        var decline = that.create({
            cdcType: spec.cdcType,
            declinedDate: el8.service.tz.now(),
            immunity: true
        }, true);

        that.saveItem(
            decline,
            false,
            { successCb: newDeclineCb }
        );
    };

    return that;

})();
